import React from 'react'

import { Grid, TextField } from '@material-ui/core'
import { BasePhoneInput } from 'components'

import { Controller, useForm } from 'react-hook-form'

import useJourneyWhiteLabel from 'hooks/useJourneyWhiteLabel'
import useGovernanceProjectNameDpo from 'hooks/useGovernanceProjectNameDpo'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

import schema from './schema'

const SubstituteDpoName = () => {
  const snackbar = useSnackbar()
  const { setCurrentStep } = useJourneyWhiteLabel()

  const {
    governanceProjectTemplate,
    governanceProjectCompany,
    substituteDpo,
    setSubstituteDpo,
  } = useGovernanceProjectNameDpo()
  const { handleSubmit, control, errors } = useForm({
    validationSchema: schema,
    defaultValues: {
      sectionName: substituteDpo?.sectionName,
      sectionResponsibleName: substituteDpo?.sectionResponsibleName,
      email: substituteDpo?.email,
      phone: substituteDpo?.phone,
      phone2: substituteDpo?.phone2,
    },
  })

  const onSubmit = async (data) => {
    try {
      await service.dponet.governanceProjectStage.nameDpo({
        token: governanceProjectTemplate?.token,
        companyDocument: helpers.regex.onlyNumbersAndLetters(
          governanceProjectCompany?.company?.document,
        ),
        governanceProjectTemplateStage: {
          ...data,
          kind: constants.governanceProjectStages.SUBSTITUTE_KIND_DPO,
        },
      })

      setSubstituteDpo(data)

      setCurrentStep((prevStep) => prevStep + 1)
    } catch (error) {
      console.error('Error submitting form:', error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    }
  }

  return (
    <form id="name-dpo-form" onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controller
            as={
              <TextField
                fullWidth
                error={errors?.sectionResponsibleName}
                helperText={errors?.sectionResponsibleName?.message}
                label="Nome completo"
              />
            }
            control={control}
            name="sectionResponsibleName"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            as={
              <TextField
                fullWidth
                error={errors?.sectionName}
                helperText={errors?.sectionName?.message}
                label="Departamento"
              />
            }
            control={control}
            name="sectionName"
          />{' '}
        </Grid>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                fullWidth
                error={errors?.email}
                helperText={errors?.email?.message}
                type="email"
                label="E-mail"
              />
            }
            name="email"
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            as={
              <BasePhoneInput
                fullWidth
                error={errors?.phone}
                helperText={errors?.phone?.message}
                label="Telefone Celular"
              />
            }
            control={control}
            name="phone"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            as={
              <BasePhoneInput
                fullWidth
                error={errors?.phone2}
                helperText={errors?.phone2?.message}
                label="Telefone Fixo"
              />
            }
            name="phone2"
            control={control}
          />
        </Grid>
      </Grid>
    </form>
  )
}

export default SubstituteDpoName
